import styled from 'styled-components'

export const H1 = styled.h1`

`

export const H2 = styled.h2`

`

export const H3 = styled.h3`

`

export const H4 = styled.h4`

`

export const H5 = styled.h5`

`



// WEBPACK FOOTER //
// ./src/components/common/text/index.js